import { __extends } from "tslib";
import React from 'react';
import throttle from 'lodash/throttle';
var defaultProps = {
    offsetTop: 0,
};
var THROTTLE_TIMEOUT = 300;
var OnScrollToElement = /** @class */ (function (_super) {
    __extends(OnScrollToElement, _super);
    function OnScrollToElement() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleOnScrollToElement = throttle(function () {
            return requestAnimationFrame(function () {
                var onScrollTo = _this.props.onScrollTo;
                var topVisibleElement = _this.getTopVisibleElement();
                if (_this.current !== topVisibleElement) {
                    _this.current = topVisibleElement;
                    onScrollTo(topVisibleElement);
                }
            });
        }, THROTTLE_TIMEOUT, { leading: false });
        return _this;
    }
    OnScrollToElement.prototype.render = function () {
        return null;
    };
    OnScrollToElement.prototype.componentDidMount = function () {
        window.addEventListener('scroll', this.handleOnScrollToElement);
    };
    OnScrollToElement.prototype.componentWillUnmount = function () {
        window.removeEventListener('scroll', this.handleOnScrollToElement);
    };
    OnScrollToElement.prototype.getTopVisibleElement = function () {
        var _a = this.props, offsetTop = _a.offsetTop, elements = _a.elements;
        var topVisibleElement = elements.find(function (elem) {
            if (elem instanceof HTMLElement) {
                var _a = elem.getBoundingClientRect(), top_1 = _a.top, height = _a.height;
                return top_1 + height - offsetTop > 0;
            }
            return false;
        });
        if (topVisibleElement) {
            return topVisibleElement;
        }
        return elements[elements.length - 1];
    };
    OnScrollToElement.defaultProps = defaultProps;
    return OnScrollToElement;
}(React.Component));
export default OnScrollToElement;
//# sourceMappingURL=OnScrollToElement.js.map